import { render } from "./AuthRecoveryPage.vue?vue&type=template&id=6f5909d1"
import script from "./AuthRecoveryPage.vue?vue&type=script&lang=js"
export * from "./AuthRecoveryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__